
import { api } from "../config";


export const apiCallsStreetCategory = {
  Actions: {
    GetCountDevices: async () => {
      try {
        const response = await api.get("StreetCategory");
        return response.data;
      } catch (error) {
        console.error(error);
      }
    },
  },
};